










































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Flipbook from 'flipbook-vue'
import { PHDController } from '@/services/request.service'

@Component({
  components: {
    Flipbook,
  },
})
export default class CourseBook extends Vue {
  private flipbook: any = {}
  private bookId = 0
  private pages: Array<any> = []
  private audios: Array<any> = []
  private pageNumList: Array<any> = []
  private currentPage = 1
  private currentLeft = ''
  private currentRight = ''
  private imageLoading = false
  private loadImageProcess = 0
  private audio: any = null
  private audioUrl = ''
  private playing = ''

  private created(): void {
    this.bookId = parseInt(this.$route.params.bookId, 10)
    this.imageLoading = true
    this.getBook()
  }

  private beforeDestroy(): void {
    if (this.audio) {
      this.audio.pause()
    }
  }

  private get devicePixelRatio(): number {
    const agent = navigator.userAgent.toLowerCase()
    if (agent.indexOf('windows') >= 0) {
      return window.devicePixelRatio
    } else {
      return 1
    }
  }

  private getBook(): void {
    PHDController.getPictureBook(this.bookId)
      .then(res => {
        const abouts = res.data.pictureBookPageUrl[1802].map(page => page.pageUrl)
        const aboutAudios = res.data.pictureBookPageUrl[1802].map(page => {
          return {
            en: page.audioEN,
            zh: page.audioCN,
          }
        })
        const pages = res.data.pictureBookPageUrl[1803].map(page => page.pageUrl)
        const pageAudios = res.data.pictureBookPageUrl[1803].map(page => {
          return {
            en: page.audioEN,
            zh: page.audioCN,
          }
        })
        let newPages = [...abouts, ...pages]
        let newAudios = [...aboutAudios, ...pageAudios]
        this.loadImages(newPages, () => {
          this.imageLoading = false
        })
        this.pages = newPages
        this.audios = newAudios
        this.currentLeft = this.pages[0]
        this.currentRight = this.pages[1]
        let list = [] as any
        newPages.forEach((page, index) => {
          if (index % 2 === 0) {
            if (index === 0) {
              list.push({
                name: this.$t('phdCourse.cover'),
                page: 1,
              })
            } else if (index === 2) {
              list.push({
                name: this.$t('phdCourse.catalog'),
                page: 3,
              })
            } else {
              list.push({
                name: index + '-' + (index + 1),
                page: index + 1,
              })
            }
          }
        })
        this.pageNumList = list
      })
      .catch(err => {
        console.warn(err)
      })
  }

  private loadImages(sources, callback): void {
    let count = 0
    let images = [] as any
    let imageNum = sources.length
    for (let i in sources) {
      if (sources[i]) {
        images[i] = new Image()
        images[i].onload = () => {
          count++
          this.loadImageProcess = Math.floor((count / imageNum) * 100)
          if (count >= imageNum) {
            callback(images)
          }
        }
        images[i].src = sources[i]
      }
    }
  }

  private flipTo(page): void {
    if (this.audio) {
      this.audio.pause()
      this.audioUrl = ''
      this.audio = null
      this.playing = ''
    }
    this.currentLeft = this.pages[page - 1]
    this.currentRight = this.pages[page]
    this.currentPage = page
  }

  private flip(page): void {
    if (page > 0 && page < this.pages.length + 1) {
      if (this.audio) {
        this.audio.pause()
        this.audioUrl = ''
        this.audio = null
        this.playing = ''
      }
      this.currentLeft = this.pages[page - 1]
      this.currentRight = this.pages[page]
      this.currentPage = page
      if (page === 1) {
        this.$message.warn(this.$tc('phdCourse.firstPage'))
      }
      if (page === this.pages.length - 1) {
        this.$message.warn(this.$tc('phdCourse.lastPage'))
      }
    }
  }

  private playAudio(locale, position): void {
    this.playing = locale + '-' + position
    const { currentPage, audios } = this
    const url = audios[position === 'left' ? currentPage - 1 : currentPage][locale]
    if (this.audio) {
      this.audio.pause()
    }
    if (this.audioUrl === url) {
      this.audioUrl = ''
      this.audio = null
      this.playing = ''
    } else {
      this.audioUrl = url
      this.audio = new Audio(url)
      this.audio.play()
      this.audio.addEventListener('ended', () => {
        this.audioUrl = ''
        this.audio = null
        this.playing = ''
      })
    }
  }

  private back(): void {
    this.$router.back()
  }
}
